export const policyInsightsQueryKeys = {
    all: ['policy'] as const,

    templates: () => [...policyInsightsQueryKeys.all, 'templates'] as const,

    templateById: (templateId: string) => [...policyInsightsQueryKeys.templates(), templateId] as const,

    insights: () => [...policyInsightsQueryKeys.all, 'insights'] as const,

    insightsConfig: () => [...policyInsightsQueryKeys.insights(), 'config'] as const
} as const;
